<wr-new-data-table
  [insideCard]="false"
  localStorageIdentifier="building-inspection-overview"
  [loadItemsFunction]="loadInspections"
  [getCountFunction]="getInspectionCount"
  (lineClick)="navigateToInspection($event)"
  [form]="inspectionListFilterForm"
  [isAdmin]="false">
  <ng-template dataTableFilter>
    @if (inspectionListFilterForm) {
    <form [formGroup]="inspectionListFilterForm" class="filter-form">
      <div>
        <label class="label" for="textFilter">Textfilter</label>
        <input type="text" nbInput id="textFilter" formControlName="text" placeholder="Filter Text...">
      </div>
      <div>
        <label class="label" for="internalTenant">Firma</label>
        <wr-tenant-select id="internalTenant"
                          [showEmptyOption]="true"
                          [tenantType]="TenantTypeEnum.Internal"
                          formControlName="assignedInternalTenantId">
        </wr-tenant-select>
      </div>
      <div>
        <label class="label" for="continuationNumber">Folgenummer</label>
        <input type="text" nbInput id="continuationNumber" min="0" formControlName="continuationNumber"
               placeholder="Folgenummer...">
      </div>
    </form>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="continuationNumber"
    display="Folgenummer">
    @if (inspection.continuationNumber) {
      <div>
        {{ inspection.continuationNumber }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="status"
    display="Status">
    @if (inspection.status) {
      <div>
        <wr-status-text [status]="inspection.status"></wr-status-text>
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="fromTimestamp"
    exportKey="fromTimestamp"
    display="Datum">
    @if (inspection.fromTimestamp) {
      <div>
        {{ inspection.fromTimestamp | date: 'dd.MM.yyyy' }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="address"
    exportKey="building.baseData.sectionText"
    display="Adresse">
    @if (inspection.building.baseData.sectionText) {
      <div>
        {{ inspection.building.baseData.sectionText }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="technician"
    exportKey="technician.fullName"
    display="Techniker*in">
    @if (inspection.technician.firstName && inspection.technician.lastName) {
      <div>
        {{ inspection.technician.firstName }} {{ inspection.technician.lastName }}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="clerk"
    exportKey="clerk.fullName"
    display="Sachbearbeiter*in">
    @if (inspection.clerk) {
      <div>
        {{ inspection.clerk.firstName }} {{ inspection.clerk.lastName }}
      </div>
    } @else {
      <div>Nicht zugewiesen</div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="tenant"
    exportKey="ownerTenant.name"
    display="Kunde">
    {{ inspection.ownerTenant?.name }}
  </ng-template>
  <ng-template
    dataColumn
    let-inspection
    key="condition"
    exportKey="condition.conditionValue"
    [exportDecimals]="2"
    display="Zustand"
    [sortable]="false">
    @if (inspection.condition.conditionValue) {
      <div>
        <wr-building-condition
          [condition]="inspection.condition.conditionValue"></wr-building-condition>
      </div>
    }
  </ng-template>
</wr-new-data-table>
